module.exports = __webpack_public_path__ + "img/Eduardo Márquez_Director de Operaciones.ae58a61e.png";